module.exports = __webpack_public_path__ + "static/media/Bitmap.56c4edd3.svg";